import { forwardRef } from 'react';

import type { IconProps } from './types';

export const DoubleChevronRight = forwardRef<SVGSVGElement, IconProps>(
  ({ color = 'currentColor', ...props }, forwardedRef) => (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
      ref={forwardedRef}
    >
      <path
        d="M11.8588 17.8695C11.7027 17.7605 11.5961 17.5941 11.5623 17.4067C11.5286 17.2193 11.5705 17.0261 11.6788 16.8695L14.9703 12.138C14.9984 12.0977 15.0134 12.0498 15.0134 12.0008C15.0134 11.9517 14.9984 11.9038 14.9703 11.8635L11.6788 7.13C11.5698 6.97319 11.5276 6.77951 11.5614 6.59155C11.5952 6.40359 11.7022 6.23676 11.8591 6.12775C12.0159 6.01875 12.2096 5.9765 12.3975 6.0103C12.5855 6.04411 12.7523 6.15119 12.8613 6.308L16.1523 11.0395C16.3473 11.3214 16.4518 11.656 16.4518 11.9988C16.4518 12.3415 16.3473 12.6761 16.1523 12.958L12.8613 17.6895C12.8073 17.7672 12.7386 17.8334 12.659 17.8845C12.5793 17.9356 12.4905 17.9705 12.3974 17.9872C12.3043 18.0039 12.2088 18.0021 12.1164 17.9819C12.024 17.9617 11.9364 17.9235 11.8588 17.8695Z"
        fill={color}
      />
      <path
        d="M7.85881 17.8695C7.70266 17.7605 7.59606 17.5941 7.56232 17.4067C7.52859 17.2193 7.57047 17.0261 7.67881 16.8695L10.9703 12.138C10.9984 12.0977 11.0134 12.0498 11.0134 12.0008C11.0134 11.9517 10.9984 11.9038 10.9703 11.8635L7.67881 7.13C7.5698 6.97319 7.52756 6.77951 7.56136 6.59155C7.59516 6.40359 7.70225 6.23676 7.85906 6.12775C8.01587 6.01875 8.20956 5.9765 8.39751 6.0103C8.58547 6.04411 8.7523 6.15119 8.86131 6.308L12.1523 11.0395C12.3473 11.3214 12.4518 11.656 12.4518 11.9988C12.4518 12.3415 12.3473 12.6761 12.1523 12.958L8.86131 17.6895C8.80732 17.7672 8.73856 17.8334 8.65895 17.8845C8.57934 17.9356 8.49045 17.9705 8.39735 17.9872C8.30425 18.0039 8.20878 18.0021 8.11637 17.9819C8.02396 17.9617 7.93644 17.9235 7.85881 17.8695Z"
        fill={color}
      />
    </svg>
  )
);

export default DoubleChevronRight;
